'use client';

import React from 'react';
import Image from 'next/image';
import ResumeAdvice from '@/components/resume/resume-marketing/ResumeAdvice';
import ResumeDiagnosis from '@/components/resume/resume-marketing/ResumeDiagnosis';
import ConsultClassify from '@/components/resume/resume-marketing/ConsultClassify';
import CreateResumeBtn from '@/components/resume/resume-marketing/CreateResumeBtn';
import SearchArea from '@/components/search/SearchArea';
import ResumeIntro from '@/components/resume/resume-marketing/ResumeIntro';
import { HotJobTitlesType } from '@/components/home-page';
import ResumeEditImage from '@/assets/resume-marketing/resume-edit.png';

const ResumeLanding = (props: { hotJobTitles: HotJobTitlesType }) => {
  const { hotJobTitles } = props;

  return (
    <>
      <div
        className="pt-16 pb-[30px] px-5 [background:linear-gradient(108.81deg,#f8fafc_1.19%,#e7f1fb_98.6%)] tablet:py-20"
        data-ele-id="content"
        data-ele-group="landing_手把手指导，轻松写出高质量简历"
        data-observer-id="landing_手把手指导，轻松写出高质量简历"
      >
        <div className="text-center">
          <p className="text-4pxl leading-14 font-semibold mb-6 tablet:text-[4rem] tablet:leading-[74px] tablet:mb-4">
            手把手指导，轻松写出高质量简历
          </p>
          <p className="text-lg text-black/65 mb-5">
            获取专家精心优化的简历建议，提升每个细节，快速吸引雇主关注。
          </p>
          <CreateResumeBtn dataEleGroup="landing_手把手指导，轻松写出高质量简历" />
        </div>
        <div className="w-full mx-auto mt-12 tablet:max-w-[1082px] tablet:mt-15">
          <Image
            src={ResumeEditImage}
            alt=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
      <ResumeAdvice />
      <ResumeDiagnosis />
      <ConsultClassify isConsultationBtnLink={true} />
      <SearchArea hotJobTitles={hotJobTitles} />
      <ResumeIntro />
    </>
  );
};

export default ResumeLanding;
